import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import SearchIcon from '@components/icons/SearchIcon'
import ClearIcon from '@mui/icons-material/Clear'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'

import { SearchFieldProps } from './types'

export const SearchField = ({ searchQuery, onSearchChange, onClearSearch, disabled }: SearchFieldProps) => {
  const [isFocused, setIsFocused] = useState(false)
  const { t } = useTranslation()

  return (
    <Box sx={{ marginLeft: 'auto', width: '300px', ml: 2 }}>
      <TextField
        value={searchQuery}
        onChange={onSearchChange}
        placeholder={!isFocused ? t(translationKeys.CUSTOM_LIST_SEARCH_PLACEHOLDER) : ''}
        variant="outlined"
        disabled={disabled}
        size="small"
        fullWidth
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        label={searchQuery || isFocused ? t(translationKeys.CUSTOM_LIST_SEARCH_PLACEHOLDER) : ''}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color={isFocused ? 'primary' : undefined} />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton
                onClick={onClearSearch}
                sx={{
                  padding: '4px',
                }}
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  )
}
